
import React from 'react';
import { BreadcrumbNavigation } from "@/components/ui/breadcrumb-list";
import { BreadcrumbItemType } from "@/components/ui/breadcrumb-list";
import { Guide } from '@/types/guides';
import { SectionHeader } from "@/components/ui/section-header";
import { FileText, Download } from "lucide-react";

interface GuideDetailHeaderProps {
  guide: Guide;
  breadcrumbItems: BreadcrumbItemType[];
}

export function GuideDetailHeader({ guide, breadcrumbItems }: GuideDetailHeaderProps) {
  return (
    <>
      <div className="mb-8">
        <BreadcrumbNavigation items={breadcrumbItems} />
      </div>
      <div className="mb-8">
        <SectionHeader
          title={guide.title}
          subtitle={guide.description}
          icon={<FileText className="h-8 w-8 text-grandpal-green-dark" />}
        />
        {guide.preview_url && (
          <p className="mt-4 text-grandpal-gray flex items-center">
            <FileText className="h-5 w-5 mr-2 text-grandpal-green-dark" />
            <span>Preview available below. Scroll down to see more details.</span>
          </p>
        )}
        {guide.download_url && (
          <p className="mt-2 text-grandpal-gray flex items-center">
            <Download className="h-5 w-5 mr-2 text-grandpal-green-dark" />
            <span>Full guide available for download in the sidebar.</span>
          </p>
        )}
      </div>
    </>
  );
}
